module.exports = __webpack_public_path__ + "img/getstarted_dashboard.eea6372c.gif";